import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    components: {
        WelcomePage: {
            component: 'Card',
            content: {
                component: 'Welcome',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/welcome',
                    component: 'WelcomePage',
                    breadcrumbName: '品真阁',
                    authentication: '/login', //加此字段为了防止用户直接访问主域名时跳转品真阁首页从而提示错误信息
                    isIndex: true,
                },
            ],
        },
    ],
};
